export default {
  title: "Configuración",
  languages: {
    en: "Inglés",
    es: "Español",
  },
  mode: {
    light: "Claro",
    dark: "Oscuro",
  },
}
